import { AnaColumn } from '../forms-template.service';
import { createGridConfig, gridDetail, gridMultiple, gridSimple, SettingGrid } from './gridSettings/gridSettings';
const genericDescrizione = [
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: false,
    colWidth: '540',
  },
];
const genericDescrizioneCodice = [
  {
    dataField: 'id',
    dataType: '',
    caption: 'Codice',
    allowEditing: false,
    colWidth: '60',
  },
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: false,
    colWidth: '540',
  },
];
const colonneSede = [
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: true,
    colWidth: '200',
  },
  {
    dataField: 'comune',
    dataType: '',
    caption: 'Località',
    allowEditing: true,
    colWidth: '100',
  },
  {
    dataField: 'indirizzo',
    dataType: '',
    caption: 'Indirizzo',
    allowEditing: true,
    colWidth: '100',
  },
];

const colonneSoggetto = [
  {
    dataField: 'ragioneSociale',
    dataType: 'string',
    caption: 'Ragione sociale',
    allowEditing: true,
    colWidth: '300',
  },
  {
    dataField: 'codiceFiscale',
    dataType: 'string',
    caption: 'Codice Fiscale',
    colWidth: '110',
    type: 'campo',
  },
  {
    dataField: 'partitaIva',
    dataType: 'string',
    colWidth: '110',
    caption: 'Partita Iva',

    type: 'campo',
  },
  {
    dataField: 'comune',
    colWidth: '240',
    caption: 'Località',
    type: 'campo',
    dataType: 'string',
  },
  {
    dataField: 'indirizzo',
    colWidth: '210',
    caption: 'Indirizzo',
    type: 'campo',
    dataType: 'string',
  },
];

const settingGridGeneric: SettingGrid = {
  masterKey: 'id',
  keyUnique: '',
  mode: null,
  selectionMode: 'single',
  remoteOperations: true,
  hoverStateEnabled: true,
  rowAlternationEnabled: true,
  repaintChangesOnly: true,
  showFilterSearch: false,
  allowUpdating: false,
  allowDeleting: false,
  allowAdding: false,
  height: 630,
  showColBlank: false,
  colonne: [
    {
      dataField: 'id',
      dataType: '',
      caption: 'Codice',
      allowEditing: true,
      colWidth: '60px',
    },
    {
      dataField: 'descrizione',
      dataType: '',
      caption: 'Descrizione',
      allowEditing: true,
      colWidth: '560px',
    },
  ],
};
export const statisticheRifiutiGrafiche: AnaColumn[] = [
  {
    itemType: 'group',
    groupDataField: 'secondoGruppo',
    class: 'p-1 pt-0',
    colCount: 3,
    colSpan: 2,
    data: [
      {
        type: 'campo',
        editorType: 'dxSelectBox',
        labelVisible: false,
        dataField: 'causali',
        //odataType:'select',
        //odataFilter:'in',
        class: 'statImpostazioni',
        nCol: 4,
        height: 230,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idCausale',
        caption: 'Causali',

        lista: {
          related: ['idCausale'],

          Async: false,
          dataSource: 'CausaleRifiuti',
          valueExpr: 'id',
          queryString: '?$filter=(isExistsPosizione eq true)',
          displayExpr: 'descrizione',
          static: false,
          isMultiple: true,
          showSelectionControls: false,
          //tipoSelect:'odata',
          // labelSelect:'Solo causali operazioni2',
        },
      },

      {
        type: 'campo',
        dataField: 'soloPosizioni',
        editorType: 'dxSelectBox',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idPosizioneRifiuto',
        labelVisible: false,
        caption: 'Posizioni',
        class: 'statImpostazioni',
        nCol: 4,
        height: 230,
        lista: {
          related: ['idPosizioneRifiuto'], //
          dataSource: 'PosizioneRifiuti',
          valueExpr: 'id',
          filter: '?$orderby=descrizione asc',
          //queryString:'?$orderby=Descrizione asc', da sistemare
          displayExpr: 'descrizione',
          static: false,
          isMultiple: true,
          showSelectionControls: false,
          tipoSelect: 'multiple',
          labelSelect: 'Solo Posizione',
        },
      },
      {
        type: 'campo',
        editorType: 'dxSelectBox',
        labelVisible: false,
        dataField: 'tipoStatistica',
        class: 'statImpostazioni',
        caption: ' Statistica',
        nCol: 4,
        height: 230,
        lista: {
          dataSource: 'statisticaPerGrafici',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true,
          isMultiple: true,
          tipoSelect: 'single',
          showSelectionControls: true,
          labelSelect: 'Statistica',
        },
      },
    ],
  },
  {
    itemType: 'group',
    groupDataField: 'filtroGruppo',
    class: 'p-1',
    colCount: 3,
    caption: 'Configurazioni Extra',
    data: [
      {
        width: 100,
        type: 'campoData', // il tipo di campo del form
        dataField: 'daData', // l'identificativo univoco del campo
        caption: 'Da Data',
        odataType: 'date',
        odataFilter: '>=',
        dataType: 'date',
        editorType: 'dxDateBox',
        format: 'dd-MM-yyyy',
        nCol: 3,
      },
      {
        width: 100,
        labelWidth: 100,
        type: 'campoData', // il tipo di campo del form
        dataField: 'aData', // l'identificativo univoco del campo
        caption: 'A Data',
        odataType: 'date',
        odataFilter: '<=',
        dataType: 'date',
        editorType: 'dxDateBox',
        format: 'dd-MM-yyyy',
        nCol: 3,
      },
      { type: 'empty' },
      //--------------------------------------------------------------------

      {
        type: 'campo', // il tipo di campo del form
        dataField: 'riferimentoDocumento', // l'identificativo univoco del campo
        caption: 'Rif. Documento',
        dataType: 'string',
        odataFilter: 'contains',
        odataType: 'string',
        staticDataField: 'riferimentoDocumento',
        nCol: 6,
      },
      {
        type: 'campo', // il tipo di campo del form
        dataField: 'isUrbano', // l'identificativo univoco del campo
        caption: 'Urbano',
        class: 'justify-content-end p-0',
        nCol: 2,
        editorType: 'dxCheckBox',
        dataType: 'string',
        odataFilter: '=',
        odataType: 'boolean',
        defaultValue: false,
      },
      {
        type: 'campo', // il tipo di campo del form
        dataField: 'isUrbanoNo', // l'identificativo univoco del campo
        caption: 'Non Urbano',
        class: 'justify-content-end pe-1',
        nCol: 2,
        editorType: 'dxCheckBox',
        dataType: 'string',
        odataFilter: '=',
        odataType: 'boolean',
        defaultValue: false,
      },
      //--------------------------------------------------------------------
      {
        type: 'campo', // il tipo di campo del form
        dataField: 'eer', // l'identificativo univoco del campo
        caption: 'E.E.R',
        nCol: 3,
        odataFilter: 'contains',
        odataType: 'string',
        // START EER ---------------------------------------
        dynamic: {
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'cer' + "?$filter=(not endswith(id,'00'))",
          service: '',
          autocomplete: false,
          caption: 'Lista EER',
          filterStatic: "?$filter=(not endswith(id,'00'))",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista EER',
            name: 'EER',
            location: 'after',
          },
          settingGrid: settingGridGeneric,
        },
        // END EER --------------------------------------
      },
      {
        type: 'campo', // il tipo di campo del form
        dataField: 'riferimentoEER', // l'identificativo univoco del campo
        caption: 'Riferim. E.E.R',
        class: 'ps-3',
        nCol: 3,
        odataFilter: 'contains',
        odataType: 'string',
        showClearButton: true,

        // il classico span di html
      },
      {
        type: 'campoSpecial',
        dataField: 'idStatoFisico',
        dataType: '',
        caption: 'Stato fis.',
        colVisible: true,
        labelVisible: true,
        class: 'stato-fisico ps-3',
        showClearButton: true,
        odataFilter: 'in',
        odataType: 'select',
        nCol: 4,
        // staticDataField:'isStatoFisico',
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'descrizione',
          dataSource: 'StatoFisico',
          service: '',
          autocomplete: false,
          caption: 'Liste Stati Fisici',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Liste Stati Fisici',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Liste Stati Fisici',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: settingGridGeneric,
        },
      },
      //--------------------------------------------------------------------
      {
        type: 'campoSpecial',
        dataField: 'idOperazioneRD',
        dataType: '',
        colCaption: 'Op.',
        caption: 'Op.smalt/recup.',
        colVisible: false,
        colSpan: 4,
        nCol: '10',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idOperazioneRD',
        editorClass: 'text-uppercase',
        dynamic: {
          displayExpr: '',
          dataSource: 'OperazioneSmaltimento',
          service: 'generic',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false,
          },
          valueExpr: 'id',
          caption: 'Lista Modalità di smaltimento/recupero',
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'OperazioneRD',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: "'Sfoglia l'elenco delle operazioni di smaltimento",
            name: 'OperazioneRD',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridMultiple,
            colonne: genericDescrizioneCodice,
          }),
        },
      },
      { type: 'empty' },
      {
        type: 'empty', // il tipo di campo del form
      },
      //--------------------------------------------------------------------

      {
        //categoriaDocumento ok
        type: 'campoSpecial',
        dataField: 'idCategoriaDocumento',
        caption: 'Categorie Doc.',
        colVisible: true,
        hideOnEdit: false,
        disableOnUpdate: true,
        width: '100',
        nCol: '10',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idCategoriaDocumento',
        dynamic: {
          dataSource: 'Categoria',
          service: 'generic',
          autocomplete: false,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          caption: 'Categoria docX.',
          queryString: '?nomeTabella=movimenti',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Categorie Documenti',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Categorie Documenti',
            name: 'categorieDoc',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridMultiple,
            colonne: genericDescrizione,
          }),
        },
      },
      {
        type: 'empty', // il tipo di campo del form
      },
      { type: 'empty' },

      //--------------------------------------------------------------------

      {
        //TipiDocumento ok
        type: 'campoSpecial',
        dataField: 'idTipoDocumento',
        caption: 'Tipo Doc.',
        colVisible: true,
        hideOnEdit: false,
        disableOnUpdate: true,
        width: '100',
        nCol: '10',
        odataFilter: 'in',
        odataType: 'select',
        staticDataField: 'idTipoDocumento',
        dynamic: {
          dataSource: 'Tipo',
          service: 'generic',
          autocomplete: false,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          caption: 'Tipo docX.',
          queryString: '?nomeTabella=movimenti',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Tipi Documenti',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Tipi Documenti',
            name: 'ListaTipiDocumenti',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridMultiple,
            colonne: genericDescrizione,
          }),
        },
      },
      {
        type: 'empty', // il tipo di campo del form
      },
      { type: 'empty' },

      //--------------------------------------------------------------------

      {
        //ZonaRaccolta ok
        type: 'campoSpecial',
        width: '100',
        nCol: '10',
        dataField: 'idZonaDocumento',
        caption: 'Zona di Raccolta',
        colVisible: true,
        hideOnEdit: false,
        disableOnUpdate: true,
        odataFilter: 'in',
        odataType: 'select',
        staticDataField: 'idZonaDocumento',
        dynamic: {
          dataSource: 'Zona',
          service: 'generic',
          autocomplete: false,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          caption: 'Tipo docX.',
          queryString: '?nomeTabella=movimenti',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Zone Raccolta',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Zone Raccolta',
            name: 'ListaZoneRaccolta',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridMultiple,
            colonne: genericDescrizione,
          }),
        },
      },
      { type: 'empty' },

      { type: 'empty' },
    ],
  },
  {
    itemType: 'group',
    groupDataField: 'sceltaProduttore',
    class: 'p-1',
    colCount: 4,
    caption: 'Produttore - Trasportatore - Destinatario - Intermediario',
    data: [
      //------------------------------- Produttore -------------------------------
      {
        type: 'campoSpecial',
        dataField: 'produttore_Descrizione_Soggetto',
        dataType: '',
        caption: 'Prod./Detentore.',
        colVisible: false,
        disableOnUpdate: true,
        nCol: 5,
        placeHolder: '',
        editorType: 'dxTextBox',
        class: 'disabled-soggetti sfondo',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'produttore_Id_Soggetto',
        dynamic: {
          dataSource: 'Soggetto',
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: 'Lista Aziende Produttrici',
          queryString: '?TipoAttivita=P',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|produttore_Id_Soggetto', 'nsAzienda', 'descrizione|produttore_Descrizione_Sede', 'id|idProduttore'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'produttore',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridDetail,
            width: 1000,
            colonne: colonneSoggetto,
          }),

          detailOption: {
            isRemote: true,
            service: 'sede',
            api: 'Sede',
            isEditable: false,
            colonne: colonneSede,
            costantValue: [{ key: 'idSoggetto', value: 'id' }],
            queryString: '/$idSoggetto?$filter=(isProduttore eq true)',
          },
        },
      },
      {
        type: 'campoSpecial',
        dataField: 'produttore_Descrizione_Sede',
        dataType: '',
        caption: 'U.L.',
        colVisible: false,
        disableOnUpdate: true,
        placeHolder: '',
        disabled: true,
        nCol: 5,
        labelWidth: 50,
        class: 'disabled-soggetti',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idProduttore',
        /*  placeHolder: 'Digita la ragione sociale o il nome dell\'unità locale di produzione', */
        dynamic: {
          dataSource: 'sede',
          service: 'sede',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: 'Lista Unica locali produttore',
          costantValue: [
            {
              key: 'produttore_Id_Soggetto',
              value: 'produttore_Id_Soggetto',
            },
          ],
          queryString: '/$produttore_Id_Soggetto?$filter=(isProduttore eq true)',
          componentType: 'dynamicGrid',
          related: ['id|idProduttore'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia U.L. Produttore',
            name: 'produttore',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,
            width: 1000,
            colonne: colonneSede,
          }),
        },
      },
      {
        type: 'empty',
      },
      {
        type: 'empty',
      },
      ///////////////////////////////////////////////////////////////////////////////////////
      {
        type: 'campoSpecial', // il tipo di campo del form
        dataField: 'autorizzazione', // l'identificativo univoco del campo
        caption: 'Autorizz.',
        disableOnUpdate: true,
        readonly: true,
        disabled: true,
        autoClear: true,
        showClearButton: true,
        editorType: 'dxTextBox',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idAutorizzazioneProduttore',
        nCol: 5,
        dynamic: {
          related: ['id|idAutorizzazioneProduttore'],
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore',
            },
          ],
          //displayExpr: 'numero',
          displayExpr: 'descrizione',
          dataSource: 'Autorizzazione',
          service: 'autorizzazione',
          valueExpr: '',
          autocomplete: true,

          static: false,
          caption: 'Elenco Autorizzazioni.',
          queryString: '/$idProduttore',
          componentType: 'dynamicGrid',
          buttonOption: {
            //
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Rimor.',
            name: 'rimor',
            location: 'after', // a destra dell'input in cui ci troviamo in devstream
          },
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'single', // single indica che puoi selezionare solo valore
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            sortingMode: 'multiple',
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 700,
            showColBlank: false,
            colonne: [
              {
                dataField: 'id',
                caption: 'Codice.',
                width: 25,
                dataType: '',
              },
              {
                dataField: 'descrizione',
                caption: 'Descrizione',

                dataType: '',
              },
            ],
          },
        },
      },
      {
        type: 'campoSpecial',
        dataField: 'idMagazzinoProduttore',
        dataType: '',
        caption: 'Magazz.',
        // colVisible: false,
        showClearButton: true,
        labelVisible: true,
        disabled: true,
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idMagazzinoProduttore',
        nCol: 5,
        labelWidth: 50,
        /* placeHolder: 'Digita il nome del magazzino..', */
        //disableOnUpdate: true,
        dynamic: {
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore',
            },
          ],
          queryString: '?idSede=$idProduttore',
          filterStatic: '',
          displayExpr: 'descrizione',
          dataSource: 'MagazzinoRifiuti',
          service: 'magazzinorifiuti',
          autocomplete: true,
          valueExpr: 'id',
          caption: 'Lista Magazzini unità locale',

          related: ['id|idMagazzinoProduttore'],
          searchOptions: {
            service: 'magazzinorifiuti',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|idMagazzinoProduttore'],
          },

          buttonOption: {
            text: 'magazzinoProduttore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista magazzinoi del soggetto selezionato',
            name: 'magazzinoProduttore',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid: createGridConfig({
            ...gridMultiple,
            width: 800,
            colonne: [
              {
                dataField: 'id',
                caption: 'Codice.',
                width: 25,
                dataType: '',
              },
              {
                type: 'campo',
                dataField: 'descrizione',
                caption: 'Magazzino',
                dataType: 'text',
                colWidth: '100',
                colVisible: true,
              },
            ],
            isOdata: false,
          }),
        },
      },
      {
        type: 'empty', // il tipo di campo del form
      },
      {
        type: 'empty', // il tipo di campo del form
      },
      /////////////////////////////////////////////////////////////////////////////////////////////////
      {
        type: 'campoSpecial',
        dataField: 'cantiereProduttore_Descrizione',
        dataType: '',
        caption: 'Cantiere',
        colVisible: false,
        labelVisible: true,
        disabled: true,
        hideOnEdit: false,
        disableOnUpdate: true,
        nCol: 5,
        editorClass: 'text-uppercase',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idCantiereFuoriUl',
        class: '',
        dynamic: {
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore',
            },
          ],
          componentType: 'dynamicGrid',
          queryString: '/$idProduttore?$filter=(isSospeso ne true)',
          displayExpr: 'descrizione',
          dataSource: 'Cantiere',
          service: 'cantiere',
          autocomplete: false,
          valueExpr: '',
          caption: 'Lista Cantieri fuiri unità locale',
          related: ['id|idCantiereFuoriUl'],
          buttonOption: {
            text: 'CantiereFuoriUl',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista dei cantieri del soggetto selezionato',
            name: 'CantiereFuoriUl',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,
            width: 1000,
            colonne: colonneSede,
          }),
        },
      },
      {
        type: 'empty', // il tipo di campo del form
      },
      {
        type: 'empty', // il tipo di campo del form
      },
      {
        type: 'empty', // il tipo di campo del form
      },
      //*********** *TRASPORTATORE* ************************ */
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty', class: 'mt-3' },
      { type: 'empty' },
      {
        type: 'campoSpecial',
        dataField: 'trasportatore_Descrizione_Soggetto',
        dataType: '',
        caption: 'Trasportatore',
        colVisible: true,
        disableOnUpdate: true,
        nCol: 5,
        class: 'disabled-soggetti sfondo',
        placeHolder: '',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idTrasportatore',
        dynamic: {
          dataSource: 'Soggetto',
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizione', //'descrizioneSoggetto'
          caption: 'Lista Aziende Trasportatori',
          queryString: '?TipoAttivita=T',
          componentType: 'dynamicGrid',
          related: [
            'idSoggetto|trasportatore_Id_Soggetto',
            'nsAzienda',
            'descrizione|trasportatore_Descrizione_Sede',
            'id|idTrasportatore',
            'id|idAutorizzazioneTrasportatore',
            'id|idAutomezzo',
            'id|idRimorchio',
            'id|idAutista',
          ],
          buttonOption: {
            text: 'Trasportatori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Trasportatori',
            name: 'trasportatore',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridDetail,
            width: 1000,
            colonne: colonneSoggetto,
          }),

          detailOption: {
            isRemote: true,
            service: 'sede',
            api: 'Sede',
            isEditable: false,
            colonne: colonneSede,
            costantValue: [{ key: 'idSoggetto', value: 'id' }],
            queryString: '/$idSoggetto?$filter=(isTrasportatore eq true)',
          },
        },
      },
      {
        nCol: 5,
        type: 'campoSpecial', // il tipo di campo del form
        dataField: 'autorizzazioneTrasporsportatore', // l'identificativo univoco del campo
        caption: 'Autorizz.',
        disableOnUpdate: true,
        labelWidth: 50,
        disabled: true,
        //odataType: 'select',
        //odataFilter: 'in',
        staticDataField: 'idAutorizzazioneTrasportatore',
        dynamic: {
          related: ['id|idAutorizzazioneTrasportatore'],
          costantValue: [{ key: 'idTrasportatore', value: 'idTrasportatore' }],
          dataSource: 'Autorizzazione',
          service: 'autorizzazione',

          queryString: '/$idTrasportatore',
          valueExpr: '',
          autocomplete: true,
          displayExpr: 'descrizione',
          static: false,
          caption: 'Elenco Descrizione Soggetto.',

          componentType: 'dynamicGrid',
          buttonOption: {
            //   text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Rimor.',
            name: 'rimor',
            location: 'after', // a destra dell'input in cui ci troviamo in devstream
          },
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'single', // single indica che puoi selezionare solo valore
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            sortingMode: 'multiple',
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 700,
            showColBlank: false,
            colonne: [
              {
                dataField: 'id',
                caption: 'Codice',
                width: 25,
                dataType: '',
              },
              {
                dataField: 'descrizione',
                caption: 'Descrizione',

                dataType: '',
              },
            ],
          },
        },
      },
      {
        type: 'empty',
      },
      {
        type: 'empty',
      },
      ////////////////////////////////////////////////////////////////////////////////
      // automezzo, rimorchio,rimorchio
      {
        //width: 100,
        nCol: 6,
        type: 'campoSpecial', // il tipo di campo del form
        dataField: 'automezzo', // l'identificativo univoco del campo
        caption: 'Targa Autom.',
        disableOnUpdate: true,
        disabled: true,
        showClearButton: true,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idAutomezzo',
        //labelWidth: 90,
        dynamic: {
          related: ['id|idAutomezzo'],

          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore',
            },
          ],
          dataSource: 'Automezzo',
          valueExpr: '',
          autocomplete: false,
          displayExpr: 'targa',
          service: 'automezzo',
          caption: 'Elenco Automezzi.',
          queryString: "/$idTrasportatore?$filter=not (tipoautomezzo eq 'D' or tipoautomezzo eq 'E' or tipoautomezzo eq 'F')",
          componentType: 'dynamicGrid',
          buttonOption: {
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Automezzi',
            name: 'sfAutomezzo',
            location: 'after', // a destra dell'input in cui ci troviamo in devstream
          },
          settingGrid: createGridConfig({
            ...gridSimple,
            width: 700,
            colonne: [
              {
                dataField: 'descrizione',
                caption: 'Descrizione',
                dataType: '',
              },
              {
                dataField: 'targa',
                caption: 'Targa',
                dataType: '',
              },
            ],
          }),
        },
      },
      //rimorchio
      {
        nCol: 6,
        type: 'campoSpecial', // il tipo di campo del form
        dataField: 'rimorchio', // l'identificativo univoco del campo
        caption: 'Rimor.',
        disableOnUpdate: true,
        disabled: true,
        showClearButton: true,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idRimorchio',

        //labelWidth: 90,
        dynamic: {
          related: ['id|idRimorchio'],
          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore',
            },
          ],
          dataSource: 'Automezzo',
          valueExpr: '',
          autocomplete: true,
          displayExpr: 'targa',
          static: false,
          caption: 'Elenco Automezzi.',
          queryString: "/$idTrasportatore?$filter= (tipoautomezzo eq 'D' or tipoautomezzo eq 'E' or tipoautomezzo eq 'F')",
          componentType: 'dynamicGrid',
          buttonOption: {
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Automezzi',
            name: 'sfAutomezzo',
            location: 'after', // a destra dell'input in cui ci troviamo in devstream
          },
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'single', // single indica che puoi selezionare solo valore
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            sortingMode: 'multiple',
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 700,
            showColBlank: false,
            colonne: [
              {
                dataField: 'descrizione',
                caption: 'Descrizione',
                dataType: '',
              },
              {
                dataField: 'targa',
                caption: 'Targa',
                dataType: '',
              },
            ],
          },
        },
      },
      { type: 'empty' },
      { type: 'empty' },
      //autista
      {
        nCol: 5,
        type: 'campoSpecial', // il tipo di campo del form
        dataField: 'autista', // l'identificativo univoco del campo
        caption: 'Autista',
        disabled: true,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idAutista',
        showClearButton: true,
        disableOnUpdate: true,
        //labelWidth: 120,
        dynamic: {
          related: ['id|idAutista'],
          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore',
            },
          ],

          dataSource: 'Autista',
          valueExpr: '',
          autocomplete: true,
          displayExpr: ['nome', 'cognome'],
          static: false,
          caption: 'Elenco Descrizione Matricole.',
          queryString: '/$idTrasportatore',
          componentType: 'dynamicGrid',
          buttonOption: {
            //   text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Rimor.',
            name: 'rimor',
            location: 'after', // a destra dell'input in cui ci troviamo in devstream
          },
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'single', // single indica che puoi selezionare solo valore
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            sortingMode: 'multiple',
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 700,
            showColBlank: false,
            colonne: [
              {
                dataField: 'nome',
                caption: 'Nome',
                width: 25,
                dataType: '',
              },
              {
                dataField: 'cognome',
                caption: 'Cognome',
                width: 25,
                dataType: '',
              },
              {
                dataField: 'matricola',
                caption: 'Matricola',

                dataType: '',
              },
            ],
          },
        },
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      // DESTINATARIO *********************************************
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty', class: 'mt-3' },
      { type: 'empty' },
      {
        type: 'campoSpecial',
        dataField: 'destinatario_Descrizione_Soggetto',
        dataType: '',
        caption: 'Destinatario',
        colVisible: true,
        disableOnUpdate: true,
        nCol: 5,
        class: 'disabled-soggetti sfondo',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'destinatario_Id_Soggetto',
        placeHolder: '',
        dynamic: {
          dataSource: 'Soggetto',
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: 'Lista Destinatari',
          queryString: '?TipoAttivita=S',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|destinatario_Id_Soggetto', 'nsAzienda', 'descrizione|destinatario_Descrizione_Sede', 'id|idDestinatario'],
          buttonOption: {
            text: 'Destinatari',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Destinatari',
            name: 'destinatari',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridDetail,
            width: 1000,
            colonne: colonneSoggetto,
          }),

          detailOption: {
            isRemote: true,
            service: 'sede',
            api: 'Sede',
            isEditable: false,
            colonne: colonneSede,
            costantValue: [{ key: 'idSoggetto', value: 'id' }],
            queryString: '/$idSoggetto?$filter=(isDestinatario eq true)',
          },
        },
      },
      {
        type: 'campoSpecial',
        dataField: 'destinatario_Descrizione_Sede',
        dataType: '',
        caption: 'U.L.',
        colVisible: false,
        disableOnUpdate: true,
        disabled: true,
        nCol: 5,
        labelWidth: 50,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idDestinatario',
        class: 'disabled-soggetti',
        dynamic: {
          dataSource: 'sede',
          service: 'sede',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: 'Lista Unica locali destinatari',
          costantValue: [
            {
              key: 'destinatario_Id_Soggetto',
              value: 'destinatario_Id_Soggetto',
            },
          ],
          queryString: '/$destinatario_Id_Soggetto?$filter=(isDestinatario eq true)',
          componentType: 'dynamicGrid',
          related: ['id|idDestinatario'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'ulDestinatario',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,
            width: 1000,
            colonne: colonneSede,
          }),
        },
      },
      {
        type: 'empty',
      },
      {
        type: 'empty',
      },
      ///////////////////////////////////////
      {
        type: 'campoSpecial', // il tipo di campo del form
        dataField: 'autorizzazioneDestinatario', // l'identificativo univoco del campo
        caption: 'Autorizz.',
        disabled: true,
        nCol: 5,
        //labelWidth: 90,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idAutorizzazioneDestinatario',

        dynamic: {
          related: ['id|idAutorizzazioneDestinatario'],
          costantValue: [
            {
              key: 'idDestinatario',
              value: 'idDestinatario',
            },
          ],
          //displayExpr: 'numero',
          displayExpr: 'descrizione',
          dataSource: 'Autorizzazione',
          service: 'autorizzazione',
          valueExpr: '',
          autocomplete: true,

          static: false,
          caption: 'Elenco Autorizzazioni.',
          queryString: '/$idDestinatario',
          componentType: 'dynamicGrid',
          buttonOption: {
            //
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Rimor.',
            name: 'rimorXX',
            location: 'after', // a destra dell'input in cui ci troviamo in devstream
          },
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'single', // single indica che puoi selezionare solo valore
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            sortingMode: 'multiple',
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 700,
            showColBlank: false,
            colonne: [
              {
                dataField: 'id',
                caption: 'Codice.',
                width: 25,
                dataType: '',
              },
              {
                dataField: 'descrizione',
                caption: 'Descrizione',

                dataType: '',
              },
            ],
          },
        },
      },

      {
        type: 'campoSpecial',
        dataField: 'magazzinoDestinatario_Descrizione',
        dataType: '',
        caption: 'Magaz.',
        colVisible: false,
        labelVisible: true,
        disabled: true,
        nCol: 5,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idMagazzinoDestinatario',

        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          costantValue: [
            {
              key: 'idDestinatario',
              value: 'idDestinatario',
            },
          ],
          queryString: '?idSede=$idDestinatario',
          filterStatic: '',
          displayExpr: 'descrizione',
          dataSource: 'MagazzinoRifiuti',
          service: 'magazzinorifiuti',
          autocomplete: true,
          valueExpr: 'id',
          caption: 'Lista Magazzini',

          related: ['id|idMagazzinoDestinatario'],
          searchOptions: {
            service: 'magazzinorifiuti',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|idMagazzinoDestinatario'],
          },

          buttonOption: {
            text: 'magazzinoDestinatario',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista magazzinoi del soggetto selezionato',
            name: 'magazzinoDestinatario',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid: createGridConfig({
            ...gridMultiple,
            width: 800,
            colonne: [
              {
                type: 'campo',
                dataField: 'descrizione',
                caption: 'Magazzino',
                dataType: 'text',
                colWidth: '100',
                colVisible: true,
              },
            ],
            isOdata: false,
          }),
        },
      },
      {
        type: 'empty', // il tipo di campo del form
      },
      {
        type: 'empty', // il tipo di campo del form
      },
      ///////////////////////////////////////////////////////////////////
      /*       {
     type: 'campoSpecial', dataField: "cantiereDestinatario_Descrizione", dataType: "",
     caption: "Cantiere",
     colVisible: false,
     labelVisible: true,
     disabled: true,
     hideOnEdit: false,
     disableOnUpdate: true,
     odataType: 'select',
     odataFilter: 'in',
     staticDataField: 'idCantiereFuoriUlDestinatario',
     nCol: 5,
     editorClass: 'text-uppercase',
     dynamic: {
       costantValue: [
         {
           key: 'idDestinatario',
           value: 'idDestinatario'
         },

       ],
       componentType: 'dynamicGrid',
       queryString: "/$idDestinatario?$filter=(isSospeso ne true)",
       displayExpr: 'descrizione',
       dataSource: "Cantiere",
       service: 'cantiere',
       autocomplete: false,
       valueExpr: '',
       caption: "Lista Cantieri",
       related: ['id|idCantiereFuoriUlDestinatario'],
       buttonOption: {
         text: 'CantiereFuoriUl',
         icon: 'glyphicon mdi mdi-playlist-plus',
         hint: 'Sfoglia la lista dei cantieri del soggetto selezionato',
         name: 'CantiereFuoriUlDestinatario',
         location: 'after',

       },
       settingGrid: createGridConfig({

         ...gridSimple,
         width: 1000,
         colonne: colonneSede
       }),

     }
   },

   {type: 'empty',},
   {type: 'empty',},
   {type: 'empty',}, */
      //////////////////////////////

      //*********** *Intermediario* ************************ */
      {
        type: 'campoSpecial',
        dataField: 'intermediario_Descrizione_Soggetto',
        dataType: '',
        caption: 'Intermedario',
        colVisible: false,
        disableOnUpdate: true,
        //colSpan: 4,
        nCol: 10,
        class: 'disabled-soggetti sfondo mt-3',
        placeHolder: '',
        odataType: 'select',
        odataFilter: 'in',
        //staticDataField:'intermediario_Id_Soggetto',

        dynamic: {
          dataSource: 'Soggetto',
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizione', //'descrizioneSoggetto'
          caption: 'Lista Intermediari',
          queryString: '?TipoAttivita=I',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|intermediario_Id_Soggetto', 'nsAzienda', 'descrizione|indermediario_Descrizione_Sede', 'id|IdIntermediario'],
          buttonOption: {
            text: 'Intermediari',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Intermediari',
            name: 'intermediari',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridDetail,
            width: 1000,
            colonne: colonneSoggetto,
          }),

          detailOption: {
            isRemote: true,
            service: 'sede',
            api: 'Sede',
            isEditable: false,
            colonne: colonneSede,
            costantValue: [{ key: 'idSoggetto', value: 'id' }],
            queryString: '/$idSoggetto?$filter=(isIntermediario eq true)',
          },
        },
      },
      {
        type: 'empty', // il tipo di campo del form
        class: 'm-0',
      },
      {
        type: 'empty', // il tipo di campo del form
        class: 'm-0',
      },
      {
        type: 'empty', // il tipo di campo del form
        class: 'm-0',
      },
    ],
  },
];

export const graficoCommento: AnaColumn[] = [
  {
    itemType: 'group',
    groupDataField: 'filtroGruppo',
    class: 'p-1 px-3',
    colCount: 1,
    data: [
      /*       {
     type: 'campo', // il tipo di campo del form
     dataField: "titoloGrafico", // l'identificativo univoco del campo
     caption: "Titolo",
     nCol: 10,
     showClearButton:true,
     visible:true
   }, */
      {
        type: 'campo', // il tipo di campo del form
        editorType: 'dxTextArea',
        dataField: 'commentiGrafico', // l'identificativo univoco del campo
        caption: 'Commenti',
        height: 100,
        nCol: 10,
        showClearButton: true,
        visible: true,
      },
    ],
  },
];
export const messaggioSemplice: AnaColumn[] = [
  {
    itemType: 'group',
    groupDataField: 'filtroGruppo',
    class: 'p-1 px-3',
    colCount: 1,
    data: [
      /*       {
     type: 'campo', // il tipo di campo del form
     dataField: "titoloGrafico", // l'identificativo univoco del campo
     caption: "Titolo",
     nCol: 10,
     showClearButton:true,
     visible:true
   }, */
      {
        type: 'campo', // il tipo di campo del form
        dataField: 'titoloGrafico', // l'identificativo univoco del campo
        caption: 'Titolo',
        nCol: 10,
        showClearButton: true,
        visible: true,
      },
      {
        type: 'campo', // il tipo di campo del form
        editorType: 'dxTextArea',
        dataField: 'msgGrafico', // l'identificativo univoco del campo
        caption: 'Messaggio',
        height: 200,
        nCol: 10,
        showClearButton: true,
        visible: true,
      },
    ],
  },
];
export const datiInGrid: AnaColumn[] = [
  {
    itemType: 'simple',
    caption: '',
    class: '',
    colCount: '1',
    data: [
      {
        type: 'campo',
        dataField: 'dataRegistrazione',
        colVisible: true,
        dataType: 'date',
        caption: 'Data Regitrazione',
        colAlignment: 'center',
        colWidth: 120
      },
      {
        type: 'campo',
        dataField: 'eer',
        colVisible: true,
        dataType: 'string',
        caption: 'E.E.R',
        colAlignment: 'center',
        colWidth: 80
      },

      {
        type: 'campo',
        dataField: 'causale_Descrizione',
        colVisible: true,
        dataType: 'date',
        caption: 'Causale',
        colWidth: 410,
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'statoFisico_Descrizione',
        colVisible: true,
        dataType: 'string',
        caption: 'Stato Fisico',
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'isUrbano',
        colVisible: true,
        dataType: 'boolean',
        caption: 'Urbano',
        colAlignment: 'center',
        colWidth: 70
      },
      /* {
        type: 'campo',
        dataField: 'idOperazioneRD',
        colVisible: true,
        dataType: 'string',
        caption: 'Op.smal/recup.',
        colAlignment: 'left'
        }, */
      {
        type: 'campo',
        dataField: 'quantitaKg',
        colVisible: true,
        dataType: 'string',
        caption: 'Quantità in Kg',
        colAlignment: 'right',
      },
      {
        type: 'campo',
        dataField: 'produttore_Descrizione_Full',
        colVisible: true,
        dataType: 'string',
        caption: 'Produttore',
        colAlignment: 'left',
        hidingPriority: 0
      },
      {
        type: 'campo',
        dataField: 'intermediario_Descrizione_Full',
        colVisible: true,
        dataType: 'string',
        caption: 'Intermediario',
        colAlignment: 'left',
        hidingPriority: 1
      },
      {
        type: 'campo',
        dataField: 'trasportatore_Descrizione_Soggetto',
        colVisible: true,
        dataType: 'string',
        caption: 'Trasportatore',
        colAlignment: 'left',
        hidingPriority: 2
      },
      {
        type: 'campo',
        dataField: 'destinatario_Descrizione_Full',
        colVisible: true,
        dataType: 'string',
        caption: 'Smaltitore',
        colAlignment: 'left',
        hidingPriority: 3,
      },
    ],
  },
];
